import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/grupos/")({
  beforeLoad: () => {
    throw redirect({ to: "/comunidades", replace: true });
  },
  component: () => null,
});
